export default "__VITE_ASSET__wYWRBw9k__"